import { useIntl } from '@/intl'
import { Banner } from '@sunwebgroup/uds-ui/banner'
import * as React from 'react'

interface AlertServiceErrorBannerProps {
  className?: string
}

export function AlertServiceErrorBanner({ className }: AlertServiceErrorBannerProps): React.ReactElement {
  const intl = useIntl()

  return (
    <Banner
      className={className}
      color="warning"
      size="S"
      hasIcon
      contentIsCentered
      text={intl.formatMessage({ id: 'price_alert_service-generic-error' })}
    />
  )
}
